import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import PermissionCheckAddCommentQuery, {
	type PermissionCheckAddCommentQuery$data,
	type PermissionCheckAddCommentQuery$variables,
} from './__generated__/PermissionCheckAddCommentQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export function preloadAddCommentPermissionCheck(contentId: string): Promise<{
	data: PermissionCheckAddCommentQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> {
	return query<PermissionCheckAddCommentQuery$data, PermissionCheckAddCommentQuery$variables>({
		query: PermissionCheckAddCommentQuery,
		variables: {
			contentId,
		},
	});
}
